import React from 'react';
import ReactDOM from 'react-dom';
import "./conf.js"
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client';
import AuthProvider from './Login/AuthContext';

const container = document.getElementById('root')
const root = createRoot(container);
root.render(
  <BrowserRouter basename="/">
    <React.StrictMode>
      <AuthProvider>
          <App/>
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
